/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Hotel } from './Hotel';
import {
    HotelFromJSON,
    HotelFromJSONTyped,
    HotelToJSON,
    HotelToJSONTyped,
} from './Hotel';

/**
 * 
 * @export
 * @interface HotelStays
 */
export interface HotelStays {
    /**
     * 
     * @type {Array<Hotel>}
     * @memberof HotelStays
     */
    hotels?: Array<Hotel>;
}

/**
 * Check if a given object implements the HotelStays interface.
 */
export function instanceOfHotelStays(value: object): value is HotelStays {
    return true;
}

export function HotelStaysFromJSON(json: any): HotelStays {
    return HotelStaysFromJSONTyped(json, false);
}

export function HotelStaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelStays {
    if (json == null) {
        return json;
    }
    return {
        
        'hotels': json['hotels'] == null ? undefined : ((json['hotels'] as Array<any>).map(HotelFromJSON)),
    };
}

export function HotelStaysToJSON(json: any): HotelStays {
    return HotelStaysToJSONTyped(json, false);
}

export function HotelStaysToJSONTyped(value?: HotelStays | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotels': value['hotels'] == null ? undefined : ((value['hotels'] as Array<any>).map(HotelToJSON)),
    };
}

